import { useEffect, useState } from "react";
import { useLevageMovementMaterialStore } from "./store/LevageMovement";
import { MaterialService } from "./core/_request";
import { HttpStatusCode } from "axios";
import { Loader } from "../../common/components/Loader/Loader";
import { LFTableV3 } from "../../common/components/LFTable/LFTableV3";
import { ColumnItem } from "../../common/models/table";

type PropsType = {
  initialValue?: any;
};
export const LevageMovement = ({ initialValue }: PropsType) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const {
    levageMaterialMovementList,
    totalItems,
    pageState,
    setLevageMovementMaterialList,
    resetLevageMovementMaterialList,
    setPageState,
    resetPageState,
  } = useLevageMovementMaterialStore();

  useEffect(() => {
    fetchAllMaterialLevageMovement({
      ...pageState,
      material: initialValue?.id,
    });
  }, [pageState, initialValue]);

  const cols: ColumnItem[] = [
    {
      key: "movementType",
      title: "Type de mouvement ",
      dataIndex: "movementType",
      show: true,
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.name ?? "-"}</span>
          </div>
        );
      },
    },
    {
      key: "quantityTxt",
      title: "Quantité ",
      dataIndex: "quantityTxt",
      show: true,
    },

    {
      key: "checkedBy",
      title: "Fait par",
      dataIndex: "checkedBy",
      show: true,

      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            {" "}
            {state?.fullname ?? "-"}{" "}
          </div>
        );
      },
    },
    {
      key: "createdAt",
      title: "Date",
      dataIndex: "createdAt",
      show: true,
    },
  ];

  const fetchAllMaterialLevageMovement = async (params?: any) => {
    try {
      resetLevageMovementMaterialList();
      setIsLoading(true);
      const res = await MaterialService.getOneLevageMaterialMovement(params);
      if (res?.status === HttpStatusCode.Ok) {
        setLevageMovementMaterialList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  return (
    <div>
      <Loader isLoading={isLoading} />

      <div className="">
        <LFTableV3
          columns={cols}
          data={levageMaterialMovementList}
          params={pageState}
          onAction={() => {}}
          onSearch={handleSetParams}
          //  onSort={handleSetParams}
          onResetSearch={() => {
            resetPageState();
          }}
          pagination={{
            defaultCurrentPage: pageState.page,
            itemsPerPage: pageState?.itemsPerPage,
            totalItems: totalItems,
          }}
          onChangePage={handleSetParams}
        />
      </div>
    </div>
  );
};
